import { render } from "./ProposalGeneralInfo.vue?vue&type=template&id=7c8d12d3&scoped=true"
import script from "./ProposalGeneralInfo.vue?vue&type=script&lang=js"
export * from "./ProposalGeneralInfo.vue?vue&type=script&lang=js"

import "./ProposalGeneralInfo.vue?vue&type=style&index=0&id=7c8d12d3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8d12d3"]])

export default __exports__